import React, { useEffect } from "react";
import axios from "axios";
import { api } from "../lib/http";

const API_BASE_URL = "https://shopaholics.ge/api";

const ProtectedRoutes = ({ setUser }) => {
  useEffect(() => {
    let isMounted = true;

    const checkSession = async () => {
      try {
        const res = await api.get(`${API_BASE_URL}/session_check.php`, {
          withCredentials: true,
        });

        // ✅ Debugging

        if (res.data && res.data.error) {
          if (["Session expired", "Unauthorized"].includes(res.data.error)) {

            await api.post(`${API_BASE_URL}/logout.php`, {}, { withCredentials: true });

            localStorage.removeItem("user");
            window.dispatchEvent(new Event("storage"));
            setUser(null);
          }
        } else if (res.data && res.data.user && res.data.user.id) {
          const storedUser = localStorage.getItem("user");
          if (isMounted && !storedUser) {
            localStorage.setItem("user", JSON.stringify(res.data.user));
            setUser(res.data.user);
          }
        }
      } catch (error) {
        console.error("❌ Session check failed:", error);
        if (isMounted) {
          setUser(null);
        }
      }
    };

    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    checkSession();
    const interval = setInterval(checkSession, 10000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [setUser]);

  return null;
};

export default ProtectedRoutes;
